/* eslint-disable no-else-return */
import { getCurrencySymbol } from '../functions/currency'
import isPopulated from '../functions/isPopulated'
import numberWithCommas from './numberWithCommas'

export default (amount, currency, includeCurrency = true) => {
  const currencyString = includeCurrency ? ` ${currency}` : ''
  if (isPopulated(amount)) {
    switch (currency) {
      case 'AUD':
        if (!Number.isNaN(parseFloat(amount))) {
          if (currency) {
            return `${getCurrencySymbol(currency)} ${numberWithCommas(parseFloat(amount).toFixed(2))}${currencyString}`
          }

          return `${numberWithCommas(parseFloat(amount).toFixed(2))}`
        } else if (currency) {
          return `${getCurrencySymbol(currency)} 0.00${currencyString}`
        }
        return '0.00'
      default:
        if (!Number.isNaN(parseFloat(amount))) {
          if (currency) {
            return `${getCurrencySymbol(currency)} ${numberWithCommas(parseFloat(amount).toFixed(2))}${currencyString}`
          }

          return `${numberWithCommas(parseFloat(amount).toFixed(2))}`
        } else if (currency) {
          return `${getCurrencySymbol(currency)} 0.00${currencyString}`
        }
        return '0.00'
    }
  }

  return '0.00'
}
